<button mat-icon-button aria-label="Navigate to Previous page" [routerLink]="navigationParams">
    <mat-icon>arrow_back</mat-icon>
</button>
<a [routerLink]="navigationParams" *ngIf="label">{{label}}</a>